export const STAKE_MAX_LENGTH = 11;

export function exceedsStakeMaxLength(stake: number): boolean {
    return stake.toString().length > STAKE_MAX_LENGTH;
}

export function calculateMaxStake(balance: number, odds: number): number {
    return odds < 0 ? Math.floor(balance / Math.abs(odds)) : Math.floor(balance);
}

export function calculateStake(maxBet: number, minBet: number, balance: number | null, currentStake: number, odds: number | undefined) {
    if (!odds) throw new Error('calculateStake:odds is undefined');
    if (Number.isNaN(maxBet)) throw new Error('calculateStake:maxBet is NaN');
    if (Number.isNaN(minBet)) throw new Error('calculateStake:minBet is NaN');
    if (Number.isNaN(currentStake)) throw new Error('calculateStake:currentStake is NaN');

    if (!isStakeWithinMaxBet(currentStake, maxBet)) {
        const maxStake = balance !== null ? calculateMaxStake(balance, odds) : maxBet;
        return { stake: Math.min(maxBet, maxStake), message: 'betSlip_errorMessage_adjustStake_maxBet' };
    }
    if (!isStakeAtLeastMinBet(currentStake, minBet)) {
        return { stake: minBet, message: 'betSlip_errorMessage_adjustStake_minBet' };
    }
    if (balance !== null && !isStakeLessBalance(currentStake, balance, odds)) {
        return { stake: calculateMaxStake(balance, odds), message: 'betSlip_errorMessage_adjustStake_balance' };
    }
    return { stake: currentStake, message: '' };
}

export function isStakeWithinMaxBet(currentStake: number, maxBet: number) {
    return currentStake <= maxBet;
}

export function isStakeAtLeastMinBet(currentStake: number, minBet: number) {
    return currentStake >= minBet;
}

export function isStakeLessBalance(currentStake: number, balance: number | null, oddsPrice: number) {
    if (balance === null) return true;

    if (oddsPrice < 0) {
        return Math.abs(oddsPrice) * currentStake <= balance;
    }
    return currentStake <= balance;
}

export function isBalanceLessMinBet(balance: number | null, minBet: number, oddsPrice: number) {
    if (balance === null) return false;

    if (oddsPrice < 0) {
        return balance < Math.abs(oddsPrice) * minBet;
    }
    return balance < minBet;
}

export function isValidStake(stake: number, maxBet: number, minBet: number, balance: number | null, price: number): boolean {
    if (isStakeWithinMaxBet(stake, maxBet)
        && isStakeAtLeastMinBet(stake, minBet)) {
        return isStakeLessBalance(
            stake,
            balance,
            price,
        );
    }
    return false;
}
